import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { CollapsibleTheme, SectionEl } from "common/components/section";
import styleOverride from "media/js/pricing/plan-builder-2023/index.inline.styl";
import { faqModal } from "./faq-modal";
import { SliderNotchSize } from "./types";
export function template() {
  var _a, _b;
  const { currentValue, disableContinue, isDragging } = this.state;
  const buildSlider = () => {
    const sliderData = this.helpers.getSliderData();
    return /* @__PURE__ */ jsx(null, null, sliderData.map((curvePoint, i) => {
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(
        "div",
        {
          sel: ".mtu-slider-part",
          style: { flexGrow: i === sliderData.length - 1 ? `0.5e+06` : curvePoint.width.toString() },
          class: { highlighted: currentValue >= curvePoint.value },
          on: { click: () => this.helpers.handleSliderPartClick(curvePoint) }
        },
        curvePoint.alwaysShowLabel ? /* @__PURE__ */ jsx("div", { sel: ".mtu-slider-label", on: { click: () => this.helpers.handleSliderPartClick(curvePoint) } }, curvePoint.label) : null
      ), curvePoint.notchSize === SliderNotchSize.LARGE ? /* @__PURE__ */ jsx(
        "div",
        {
          sel: ".mtu-10k-tick",
          class: { highlighted: currentValue >= curvePoint.value },
          on: { click: () => this.helpers.handleSliderPartClick(curvePoint) }
        }
      ) : curvePoint.notchSize === SliderNotchSize.SMALL ? /* @__PURE__ */ jsx(
        "div",
        {
          sel: ".mtu-1k-tick",
          class: { highlighted: currentValue >= curvePoint.value },
          on: { click: () => this.helpers.handleSliderPartClick(curvePoint) }
        }
      ) : null);
    }), /* @__PURE__ */ jsx("div", { sel: ".end-arrow", class: { highlighted: currentValue === sliderData[sliderData.length - 1].value } }));
  };
  const renderThumbSlider = () => {
    const currNotch = this.helpers.getCurrentNotch();
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".moving-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: `caret-left` } }), /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: `caret-right` } })), /* @__PURE__ */ jsx("div", { sel: ".arrow-pointer" }), /* @__PURE__ */ jsx("div", { sel: ".arrow-pointer-box" }), currNotch && currNotch.label ? /* @__PURE__ */ jsx("div", { sel: ".mtu-thumb-label", style: { left: currentValue < 1e4 ? `2px` : `0` } }, this.helpers.getCurrentNotch().label) : null);
  };
  let stepTitleCopy = `Select Your Monthly Event Volume + Plan Type`;
  if (this.attr(`mp-2023-style`)) {
    const hasPlan = !!((_b = (_a = this.app.state.customerInfo) == null ? void 0 : _a.orgInfo) == null ? void 0 : _b.orgId);
    stepTitleCopy = hasPlan ? `Modify your plan` : `Create your plan`;
  }
  return /* @__PURE__ */ jsx("div", { sel: this.attr(`mp-2023-style`) ? `.mp2023-mtu-slider` : `.mtu-slider` }, this.helpers.showUsageCallout() ? /* @__PURE__ */ jsx(null, null, this.attr(`is-reverse-trial`) ? null : /* @__PURE__ */ jsx("div", { sel: ".step-usage-callout-wrapper" }, this.attr(`mp-2023-style`) ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".step-usage-current" }, "You had", ` `, /* @__PURE__ */ jsx("span", { sel: ".step-usage-number" }, this.helpers.getRecommendedUsageAmount().toLocaleString(), " events"), ` `, "last month"), /* @__PURE__ */ jsx("div", { sel: ".step-usage-link" }, /* @__PURE__ */ jsx("a", { attrs: { href: this.helpers.getUsageHref(), target: `_blank` } }, "view usage"))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".step-usage-current" }, "Last Month"), /* @__PURE__ */ jsx("div", { sel: ".step-usage-number" }, /* @__PURE__ */ jsx("div", { sel: ".step-usage-number-blue" }, this.helpers.getRecommendedUsageAmount().toLocaleString())), /* @__PURE__ */ jsx("div", { sel: ".step-usage-mtus-per-month" }, "Events"), /* @__PURE__ */ jsx("div", { sel: ".step-usage-link" }, /* @__PURE__ */ jsx("a", { attrs: { href: this.helpers.getUsageHref(), target: `_blank` } }, "view usage")))), this.helpers.getPlanRecommendationInfo() ? /* @__PURE__ */ jsx("div", { sel: ".plan-recommendation-callout-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".plan-recommendation-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: `idea` } })), /* @__PURE__ */ jsx("div", { sel: ".plan-recommendation-text" }, this.helpers.getPlanRecommendationInfo())) : null) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".step-title" }, stepTitleCopy), /* @__PURE__ */ jsx("div", { sel: ".step-description" }, "Use the slider to select your monthly event volume.")), /* @__PURE__ */ jsx("div", { sel: ".mtu-slider-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".mtu-slider-parts" }, buildSlider()), /* @__PURE__ */ jsx(
    "div",
    {
      sel: ".mtu-slider-drag-thumb",
      style: { transform: this.helpers.getThumbTransform() },
      class: { dragging: isDragging },
      on: {
        mousedown: this.helpers.handleDragThumbMouseDown,
        touchstart: this.helpers.handleDragThumbMouseDown
      }
    },
    renderThumbSlider()
  )), /* @__PURE__ */ jsx("div", { sel: ".buttons-row" }, /* @__PURE__ */ jsx(
    ButtonEl,
    {
      sel: ".continue-button",
      attrs: {
        theme: this.attr(`mp-2023-style`) ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
        role: `button`,
        tabindex: 0,
        "style-override": styleOverride,
        disabled: disableContinue,
        size: ButtonSize.Large
      },
      on: {
        click: this.helpers.handleContinue
      }
    },
    "Continue"
  ), this.attr(`mp-2023-style`) && /* @__PURE__ */ jsx(
    "div",
    {
      sel: ".faq-button",
      attrs: {
        role: `button`,
        tabindex: 0
      },
      on: {
        click: this.helpers.handleFaqModal,
        keydown: (ev) => {
          (ev.key === `Enter` || ev.key === ` `) && this.helpers.handleFaqModal(ev);
        }
      }
    },
    /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: `brand-help` } }),
    "How to choose event volume"
  )), this.attr(`mp-2023-style`) ? faqModal(
    this.state.isFaqModalOpen,
    this.helpers.handleFaqModal,
    this.app.helpers.getOveragePricePerEventString()
  ) : /* @__PURE__ */ jsx("div", { sel: ".faqs" }, /* @__PURE__ */ jsx("div", { sel: ".faq-row" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: `brand-help` } }), /* @__PURE__ */ jsx(
    SectionEl,
    {
      attrs: {
        "header-title": `How many monthly events should I select?`,
        theme: CollapsibleTheme.INLINE,
        "is-closed": true,
        "style-override": styleOverride
      }
    },
    /* @__PURE__ */ jsx("div", null, "We encourage new customers to get started on the free plan and then upgrade once they have an estimate of their volume.", /* @__PURE__ */ jsx("br", null), /* @__PURE__ */ jsx("br", null), "However if you'd like to quickly estimate your monthly event volume multiply the number of MAU (Monthly Active Users) engaging with your product by the estimated number of interactions (events) each user performs each month. On average our paid accounts track 44 events per user.", /* @__PURE__ */ jsx("br", null), /* @__PURE__ */ jsx("br", null), "Overall we believe events are a better fit for most of our accounts but there are some scenarios where MTUs can be advantageous. If you'd like to learn more,", ` `, /* @__PURE__ */ jsx("a", { sel: ".faq-contact-sales-link", attrs: { href: `/contact-us/sales` } }, "contact sales"), ".")
  )), /* @__PURE__ */ jsx("div", { sel: ".faq-row" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: `brand-help` } }), /* @__PURE__ */ jsx(
    SectionEl,
    {
      attrs: {
        "header-title": `What is the rate if I go over my estimate?`,
        theme: CollapsibleTheme.INLINE,
        "is-closed": true,
        "style-override": styleOverride
      }
    },
    /* @__PURE__ */ jsx("div", null, this.app.helpers.getOveragePricePerEventString() ? /* @__PURE__ */ jsx(null, null, "Once you've finished using your selected plan amount of", ` `, /* @__PURE__ */ jsx("strong", null, this.app.helpers.getSelectedCapAbbreviated(), " prepaid events"), ", you'll be charged at our regular monthly rate of ", /* @__PURE__ */ jsx("strong", null, this.app.helpers.getOveragePricePerEventString()), " for each additional event tracked that month.") : null, /* @__PURE__ */ jsx("br", null), /* @__PURE__ */ jsx("br", null), "Additionally, volume discounts are baked in. You can save money by giving your company room to grow!")
  ))));
}
